import styled from 'styled-components';
import '../../styles/opensans.less';

export const Wrapper = styled.div`
  position: relative;
  height: calc(100% - 8px);
  background: #fff;
  margin: 8px;
  overflow: hidden;
`;

export const TabRow = styled.div`
  position: relative;
  width: 100%;
  height: 20px;
`;
